import {selector} from "./selector";
import { translate } from "../../../app/localisation";

let isClick = false;

const invoicePreviewModal = function (e) {
    e.preventDefault();
    const bill = $(e.target).closest('tr').data('entity');
    const currency = $(e.target).data('currency');
    const $modal = $(selector.invoiceModal).modal('show');
    var localizedMessage = messages.customer_pay_bills_success; 
    
    API.service.customer.getBillInvoiceData(bill.id, currency).done(function (response) {
        $modal.find('.modal-body').html(response);
    });
}

const addCreditAmount = function () {
    let amount = parseInt($(selector.chargeAmount).val());
    let $preloader = $(selector.preloader);

    $preloader.html($(selector.preloaderText).val());

    API.service.customer.addCredit(amount)
        .done(function (response) {
            $preloader.html(response['message']);
        })
        .fail(function (response) {
            $preloader.html(response['message']);
        });
}
const payBill = (e) => {
    e.preventDefault();
    const billId = $(e.target).closest('tr').data('entity');
    const $modal = $(selector.modalPayBill).modal("show");
    API.service.customer.customerPayBill(billId).done(function (response) {
        $modal.find('.modal-body').html(response);
        $modal.find(selector.btnMakePayment).off('click').on('click', {
            billId: billId,
            modal: $modal,
        }, _makePayment);
    });
}

const _makePayment = function (e) {
    e.preventDefault();
    let billId = e.data.billId;
    let $modal = e.data.modal;
    let $alert = $(selector.paymentAddAlert);

    if (isClick) {
        return;
    }
    isClick = true;

    $modal.find(selector.btnMakePayment).remove();
    $alert.attr('class', 'alert alert-warning').html(translate('payment_in_progress')).show();

    API.service.customer.customerPayBill(billId).done(function (response) {
        API.service.customer.getCustomerPayBill(billId).done(function (res) {
            if(res.message){
                $alert.attr('class', 'alert alert-success').html(res.message).show();
            }
            if(res.error){
                $alert.attr('class', 'alert alert-danger').html(res.error).show();
            }
            isClick = false;
            setTimeout(function (){
                window.location.reload();
          }, 5000);
        }).fail(function (res) {
            isClick = false;
            console.log(res);
            $alert.attr('class', 'alert alert-danger').html(res.message).show()
        });
    }).fail(function (response) {
        isClick = false;
        let errorsHtml = '';
        if (response.hasOwnProperty('responseJSON')) {
            if (response.responseJSON.hasOwnProperty('errors')) {
                let errors = response.responseJSON.errors;
                for (let prop in errors) {
                    if (errors.hasOwnProperty(prop)) {
                        errorsHtml += '<div>' + errors[prop] + '</div>';
                    }
                }
            } else {
                errorsHtml = translate('error_general');
            }
        } else {
            errorsHtml = translate('error_general');
        }
        $alert.attr('class', 'alert alert-danger').html(errorsHtml);
    });
}

export {invoicePreviewModal, addCreditAmount, payBill, _makePayment};